var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"ma-10 text-center"},[_c('v-progress-circular',{staticClass:"darkmode-ign",attrs:{"indeterminate":"","color":"primary"}})],1),_c('p',{staticClass:"ma-10"},[_vm._v("Bitte warte einen Moment.")])])}
var staticRenderFns = []

export { render, staticRenderFns }